export const logo = ['608 134', ``]